const PubSub = require("underpub-js");
const { gsap } = require("gsap/dist/gsap");

const listingShowcase = function(options) {

	this.options = {
		$el: false,
		baseClass: "comp-ListingShowcase",
	};

	$.extend(true, this.options, options);

};

listingShowcase.prototype.init = function() {
	
	const self = this;

	self.$bgImageListingItems = self.options.$el.find(`.${self.options.baseClass}__listing--themeBgImage`);

	self.$bgImageListingItems.on('mouseenter', function() {
		self.bgImageListingMouseEnter($(this));
	}).on('mouseleave', function() {
		self.bgImageListingMouseOut($(this));
	});

};

listingShowcase.prototype.bgImageListingMouseEnter = function($listingItem) {
	
	const self = this;

	let $contentItems = $listingItem.find(`.${self.options.baseClass}__listing__content__label, .${self.options.baseClass}__listing__content__heading, .${self.options.baseClass}__listing__content__copy, .${self.options.baseClass}__listing__content__link`);
	let $imageOverlay = $listingItem.find(`.${self.options.baseClass}__listing__image__overlay`);

	gsap
	.timeline({
		
	})
	.to($contentItems, {
		duration: 0.25,
		stagger: 0.08,
		y: 0,
		opacity: 1,
	})
	.to($imageOverlay, {
		duration: 0.25,
		opacity: 1
	}, "<");

};

listingShowcase.prototype.bgImageListingMouseOut = function($listingItem) {
	
	const self = this;

	let $contentItems = $listingItem.find(`.${self.options.baseClass}__listing__content__label, .${self.options.baseClass}__listing__content__heading, .${self.options.baseClass}__listing__content__copy, .${self.options.baseClass}__listing__content__link`);
	let $imageOverlay = $listingItem.find(`.${self.options.baseClass}__listing__image__overlay`);

	gsap
	.timeline({
		
	})
	.to($contentItems, {
		overwrite: true,
		duration: 0.25,
		opacity: 0,
	})
	.to($imageOverlay, {
		duration: 0.25,
		opacity: 0
	}, "<")
	.set($contentItems, {
		y: 10
	});

};

module.exports = listingShowcase;
